<!--

Copyright Paul B. Lucas (C) 2025  ALL RIGHTS RESERVED.
Licensed to the University of Illinois Urbana Champaign

This component is rendered by receiver roles.  Allows creation of asset.
Revisions:
    03/10/2025      pblucas     initial creation
 

-->
<template>
    <!-- master container set size relative to viewport -->
    <div class="_master_container">
        <!-- establishes column based flex container -->       

        <!-- asset identifying information-->
        <div class="_fieldset_edit" v-if="(renderState == 'EDIT-ASSET') || renderState == 'REEDIT-ASSET'">
            <div class="_fieldset_form" style="order: 1;"> 
                <div class="_header_field" >   
                  
                        <div class="_col_50">
                            <p class="_p_fr_container_label">Asset Basic Information </p> 
                            <div v-if="renderState == 'REEDIT-ASSET'">
                                <p class="_p_item_label">Asset Steward:<span class="_p_item_text">{{ asset['steward'] }}</span></p>
                                <p class="_p_item_label">Owner Org:   <span class="_p_item_text">{{ asset['owner-org'] }}</span></p> 
                                <p class="_p_item_label">UUID:  <span class="_p_item_text_diminished">{{ asset.uuid }}</span></p>
                            </div>
                        </div>
                        <div id="_tag_pdf" class="_col_50" v-if="asset['tag'].length > 0">
                            <p class="_ui_tag_text">University of Illinois Urbana-Champaign</p>
                            <vue3-barcode class="_ui_tag_code" :value="asset['tag']" :height="50" />
                        </div>
                       
                </div>                  
                <div class="_property_box_blue">
                    <form class='_form_blue'>                  
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-1">Asset Type</label>
                            </div>
                            <div class="_col_60">
                                <select id="ABI-1" class="_select" v-model="asset['asset-type']">
                                    <option id="typeOption" class="_asset_types" disabled  >{{ asset['asset-type'] }}</option>
                                    <option id="typeOption" class="_asset_types" v-for="(item, idx) in aAssetTypes" :value="item" > {{item.toUpperCase()}} </option>
                                </select>
                            </div> 
                         </div>   
                         <!-- Owner org should be entered prior to autogenerating any TAG -->
                         <div class="_row">
                            <p class="_p_diminished_grn">Enter Owner Org prior to generating unique ID.</p>
                         </div>
                         <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI=2.1">Owner Org</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-2.1" class="_input" type="text"  v-model="asset['owner-org']">
                            </div>
                         </div>

                         <!-- Asset TAG Management  (Tag change on reedit not allowed)  -->
                         <div class="_row" style="justify-content:space-between;" v-if="renderState == 'EDIT-ASSET'">
                            <div class="_col_60">
                                <p order="1" class="_p_diminished_grn">Enter TAG number or click to autogenerate unique ID. </p>                              
                            </div>
                            <div class="_col_30">
                                <button order="2" class="_fcn_button"   @click.prevent="generatePTAG()">Create New TAG</button>  
                            </div>
                         </div>
                         <div class="_row" v-if="renderState == 'EDIT-ASSET'">
                             <div class="_col_40">
                                <label class="_label" for="ABI-2">Tag/Identifying Number</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-2" class="_input" type="text" required v-model="asset.tag">
                            </div>
                        </div>
                         <div class="_row" v-if="renderState == 'REEDIT-ASSET'">
                             <div class="_col_40">
                                <label class="_label" for="ABI-2">Tag/Identifying Number</label>
                            </div>
                            <div class="_col_60"> 
                                <p class="_p_item_text"><b>{{asset.tag}}</b></p>
                            </div>
                        </div>

                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI=3">Serial Number</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-3" class="_input" type="text"  v-model="asset['serial-no']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-7" >Invoice Number</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-7" class="_input" type="text" required v-model="asset['invoice-number']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-11" >Purchase Date</label>
                            </div>
                            <div class="_col_60">
                                <VueDatePicker id="FW-11" class="_date_picker" required v-model="asset['purchase-date']" :format="useFormat"  />
                             </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-2" >Original Purchase Cost</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-2" class="_input" type="text" required v-model="asset['cost']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-3">Property Category</label>
                            </div>
                            <div class="_col_60">
                                <select id="FW-3" v-model="asset['category']" class="_select" >
                                    <option id="typeOption2" class="_asset_types" disabled  >{{ asset['category'] }}</option>
                                    <option id="typeOption2" class="_asset_types" v-for="(item, idx) in aPropClass" :value="item" > {{item}} </option>
                                </select>

                            </div>
                        </div>
                        <hr />


                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-4">Manufacturer</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-4" class="_input" type="text"  v-model="asset.mfg">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-5">Model</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-5" class="_input" type="text"  v-model="asset.model">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-6">Other Identifying Marks</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-6" class="_input" type="text"  v-model="asset['other-ids']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-9">Description</label>
                            </div>
                            <div class="_col_60">
                                <textarea id="ABI-9" class="_textarea" required 
                                v-model="asset.description"></textarea>   
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-1">Chart</label>
                            </div>
                            <div class="_col_60">
                                <select id="FW-1" v-model="asset['chart']" class="_select" >
                                    <option id="typeOption" class="_asset_types" disabled  >{{ asset['chart'] }}</option>
                                    <option id="typeOption" class="_asset_types" v-for="(item, idx) in aChartEnums" :value="asset['chart']" > {{item}} </option>
                                </select>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-14" >Unit</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-14" class="_input" type="text" required v-model="asset['unit']">
                            </div>
                        </div>
                         <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-4" >Origination ID (OTag)</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-4" class="_input" type="text" required v-model="asset['otag']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-5" >Banner Location Code</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-5" class="_input" type="text" required v-model="asset['location']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-6" >Banner Location Detail</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-6" class="_input" type="text" required v-model="asset['location-detail']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-8" >IT Data (reserved)</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-8" class="_input" type="text" required v-model="asset['it-data']">
                            </div>
                        </div>
                        <div class="_row">
                            <!-- area for the asset notes -->
                            <div class="_col_40">
                                <label class="_label" for="FW-9">Notes</label>
                            </div>
                            <div class="_col_60">
                                <textarea id="FW-9" class="_textarea"  
                                    v-model="asset['notes']">
                                </textarea>  
                            </div>                            
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-10" >Original Item ID</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-10" class="_input" type="text" required v-model="asset['orig-item-id']">
                            </div>
                        </div>
                         <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-12" >Replacement Cycle (yrs)</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-12" class="_input" type="text"  v-model="asset['replacement-cycle']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-15" >Warranty Expiration Date</label>
                            </div>
                            <div class="_col_60">
                                <VueDatePicker id="FW-15" class="_date_picker" required v-model="asset['warranty-expiration']" :format="useFormat"  />
                             </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!--After save, renders entire asset for review -->
        <div v-if="renderState == 'REVIEW-ASSET'">
            <div class="_fieldset_flex_col">
                <div class="_major_property_container" style="order: 1;">
                    <!-- row for asset owner/steward and uuid-->
                    <div class="_header_field" >   
                  
                        <div class="_col_50">
                            <p class="_p_item_label">Asset Steward:<span class="_p_item_text">{{ asset['steward'] }}</span></p>
                            <p class="_p_item_label">Owner Org:   <span class="_p_item_text">{{ asset['owner-org'] }}</span></p> 
                            <div v-if="asset.uuid.length > 0">
                                <p class="_p_item_label">UUID:  <span class="_p_item_text_diminished">{{ asset.uuid }}</span></p>
                            </div>  
                            <div v-else>
                                <p class="_p_item_label">UUID:  <span class="_p_item_text_diminished" style="color: green;">Will be set on save</span></p>
                            </div>     
                            
                        </div>
                        <div id="_tag_pdf" class="_col_50" v-if="asset['tag'].length > 0">
                            <p class="_ui_tag_text">University of Illinois Urbana-Champaign</p>
                            <vue3-barcode class="_ui_tag_code" :value="asset['tag']" :height="50" />
                        </div>
                       
                    </div>                  
                </div>
            </div>

            <!-- asset identifying information-->
            <div class="_fieldset_flex_row" >
                <div class="_fieldset_flex_col" >
                    <p class="_p_group_container_label" style="order: 1">Asset Basic Information</p>
                    <div class="_property_group_box" style="order: 2">
                        <div class="_assets_table">
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Tag/Identifying Number</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text"><b>{{asset.tag}}</b></p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Asset Type</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{ prettyType(asset['form-type'])}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Serial Number</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset['serial-no']}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Description</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset['description']}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Manufacturer</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset.mfg}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Model</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset.model}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Other Identifying Marks</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset['other-ids']}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">IP Vers 4 Address</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset['ipv4-address']}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">IP Vers 6 Address</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset['ipv6-address']}}</p>
                                </div>
                            </div>
                        
                        </div>
                    </div>
                    <p class="_p_group_container_label" style="order: 3;">State of Illinois Auditing Information</p>
                    <div class="_property_group_box_audit" style="order:4">
                        
                        <div class="_assets_table">
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Audit Category</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text"><b>{{asset['audit-category']}}</b></p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Date of Last Audit</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{prettyDate(asset['date-last-audit'])}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Machine Name</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset['machine-name']}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Operating System Type</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset['os-type']}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Operating System Version</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset['os-version']}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Anti-virus Name</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset['av-name']}}</p>
                                </div>
                            </div>
                            <div class="_row">
                                <div class="_col_50">
                                    <p class="_p_item_label">Anti-virus Version</p>
                                </div>
                                <div class="_col_50">
                                    <p class="_p_item_text">{{asset['av-version']}}</p>
                                </div>
                            </div>
                        </div>
                    </div>      
                </div>
                <div class="_fieldset_flex_col">
                    <!-- data classification -->
                    <div class="_property_group_container" style="order: 1;">
                        <p class="_p_group_container_label">Information Security</p>
                        <div class="_property_group_box">
                            <div class="_assets_table">
                                <div class="_row">
                                    <div class="_assets_check_label_table_cell">
                                        <p class="_p_item_label">Asset contains sensitive data</p>
                                    </div>
                                    <div class="_assets_check_table_cell">
                                        <div class="_checks"  v-if="asset['has-sensitive-data']"><img src="@/assets/check-green.png" width="10" /></div>
                                        <div class="_checks"  v-else><img src="@/assets/red-x.png" width="10" /></div> 
                                    </div>           
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Classification of Data</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{asset['data-class']}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="_property_group_container" style="order:2;">
                        <p class="_p_group_container_label">FabWeb+ Data</p>
                        <div class="_property_group_box">
                            <div class='_assets_table'>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Chart</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ asset['chart'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Original Purchase Cost</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">${{(asset?.cost ?? 0.0).toFixed(2)}}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Property Category</p>
                                    </div>
                                    <div class="_col_50">   
                                        <p class="_p_item_text">{{ asset['category'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Origination ID (OTag)</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ asset['otag'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Banner Location Code</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ asset['location'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Banner Location Detail</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ asset['location-detail'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Invoice Number</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ asset['invoice-number'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">IT Data (reserved)</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ asset['it-data'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <!-- area for the asset notes -->
                                    <div class="_col_50">
                                        <p class="_p_item_label">Notes</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text_ellipsis">{{ asset['notes'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Original ID</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ asset['orig-item-id'] }} </p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Purchase Date</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ prettyDate(asset['purchase-date']) }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Replacement Cycle (yrs)</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ asset['replacement-cycle'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Asset Status</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ asset['status'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Unit</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ asset['unit'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <div class="_col_50">
                                        <p class="_p_item_label">Warranty Expiration Date</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">{{ asset['warranty-expiration'] }}</p>
                                    </div>
                                </div>
                                <div class="_row">
                                    <p class="_p_diminished_grn">S/L depreciation, 1 period residual</p>
                                </div>
                                <div class="_row">                         
                                    <div class="_col_50">
                                        <p class="_p_item_label">Net Present Value (NPV)</p>
                                    </div>
                                    <div class="_col_50">
                                        <p class="_p_item_text">${{ calcNPV }}</p>
                                    </div>
                                </div>
                            </div>      
                        </div>
                    </div>
                </div>
            </div>
            <!-- auditing information -->
            <div class="_fieldset_flex_row">           
                <!-- Boolean configuration checks -->
                <div class="_fieldset_flex_col" style="order:1;">           
                    <p class="_p_group_container_label" >Audit Configuration Checks</p>
                    <div class="_property_group_box_audit">
                        <div class="_assets_table">
                            <div class="_row">
                                <div class="_assets_check_label_table_cell">
                                    <p class="_p_item_check_label">Anti-virus Installed and Operating</p>
                                </div>
                                <div class="_assets_check_table_cell">
                                    <div class="_checks" v-if="asset['av-installed']"><img src="@/assets/check-green.png" width="10" /></div>
                                    <div class="_checks" v-else><img src="@/assets/red-x.png" width="10" /></div> 
                                </div>               
                            </div>
                            <div class="_row">
                                <div class="_assets_check_label_table_cell">
                                    <p class="_p_item_check_label">Firewall Installed, Configured, and Operating</p>
                                </div>
                                <div class="_assets_check_table_cell">
                                    <div class="_checks" v-if="asset['firewall-active']"><img src="@/assets/check-green.png" width="10" /></div>
                                    <div class="_checks" v-else><img src="@/assets/red-x.png" width="10" /></div> 
                                </div>              
                            </div>
                            <div class="_row">
                                <div class="_assets_check_label_table_cell">
                                    <p class="_p_item_check_label">User is Admin on Machine</p>
                                </div>
                                <div class="_assets_check_table_cell">
                                    <div class="_checks" v-if="asset['user-is-admin']"><img src="@/assets/check-green.png" width="10" /></div>
                                    <div class="_checks" v-else><img src="@/assets/red-x.png" width="10" /></div> 
                                </div>           
                            </div>
                            <div class="_row">
                                <div class="_assets_check_label_table_cell">
                                    <p class="_p_item_check_label">Asset Identified as UIUC Property</p>
                                </div>
                                <div class="_assets_check_table_cell">
                                    <div class="_checks" v-if="asset['identified-as-uiuc']"><img src="@/assets/check-green.png" width="10" /></div>
                                    <div class="_checks" v-else><img src="@/assets/red-x.png" width="10" /></div> 
                                </div>               
                            </div>
                            <div class="_row">
                                <div class="_assets_check_label_table_cell">
                                    <p class="_p_item_check_label">CrowdStrike Falcon Sensor Active</p>
                                </div>
                                <div class="_assets_check_table_cell">
                                    <div class="_checks" v-if="asset['crowdstrike-active']"><img src="@/assets/check-green.png" width="10" /></div>
                                    <div class="_checks" v-else><img src="@/assets/red-x.png" width="10" /></div> 
                                </div>           
                            </div>
                            <div class="_row">
                                <div class="_assets_check_label_table_cell">
                                    <p class="_p_item_check_label">Disk is Encrypted</p>
                                </div>
                                <div class="_assets_check_table_cell">
                                    <div class="_checks" v-if="asset['disk-encrypted']"><img src="@/assets/check-green.png" width="10" /></div>
                                    <div class="_checks" v-else><img src="@/assets/red-x.png" width="10" /></div> 
                                </div>           
                            </div>
                            <div class="_row">
                                
                            </div>
                        </div>
                    </div>      
                </div>
            </div>
        </div>
        <!-- controls  -->
        <div class="_assets_controls">
            <br/>
            <button class="_main_button" type="button" v-if="renderState =='EDIT-ASSET'"
                tabindex="0"
                aria-label="Cancel edits" 
                aria-description="Cancels current edit and returns asset to pre-edit state" 
                @click="cancelEdit()"
                @keydown.enter="cancelEdit()">Cancel </button>
            <button class="_main_button" type="button" v-if="renderState == 'REEDIT-ASSET'"
                tabindex="0"
                aria-label="Cancel edits" 
                aria-description="Cancels current edit and returns asset to pre-edit state" 
                @click="cancelReEdit()"
                @keydown.enter="cancelReEdit()">Cancel </button>
            <button class="_main_button" type="button" v-if="renderState =='EDIT-ASSET' || renderState == 'REEDIT-ASSET'"
                tabindex="0" 
                aria-label="Save edited asset" 
                aria-describedby="Saves the current asset" 
                @click="saveAsset()"
                @keydown.enter="saveAsset()">Save </button>
            <button class="_main_button" type="button" v-if="renderState =='REVIEW-ASSET'"
                tabindex="0" 
                aria-label="Generate another asset" 
                aria-describedby="Reopen edit field for new asset" 
                @click="anotherAsset()"
                @keydown.enter="anotherAsset()">Enter another Asset </button>
            <button class="_main_button" type="button" v-if="renderState =='REVIEW-ASSET'"
                tabindex="0" 
                aria-label="Print PTAG" 
                aria-describedby="Print the PTAG" 
                @click="printPTAG()"
                @keydown.enter="printPTAG()">Print the PTAG</button>
            <button class="_main_button" type="button" v-if="renderState =='REVIEW-ASSET'"
                tabindex="0" 
                aria-label="Edit this asset" 
                aria-describedby="Reopen edit field" 
                @click="editAsset()"
                @keydown.enter="editAsset()">Edit This Asset </button>
            <div class="_saved_right" style="order: 3;" v-if="savedFlag && ((renderState == 'EDIT-ASSET') || (renderState == 'REEDIT-ASSET'))">
                <p class="_p_saved">Asset Updated</p>
            </div>

        </div>
    <!-- end of master container -->
    </div>
</template>
<script>
    import {ref, computed }             from 'vue'
    import { useStore }                 from 'vuex'
  
    import useAssetsAPI                 from  '@/composables/useAssetsAPI'
    import useDateHelpers               from  '@/composables/useDateHelpers'
    import useRefreshAPI                from  '@/composables/useRefreshAPI'
    import usePermissionsAPI            from  '@/composables/usePermissionsAPI'
    import useNextAvailableNumberAPI    from  '@/composables/useNextAvailableNumberAPI'
    import useConfigAPI                 from  '@/composables/useConfigAPI'       

    // calendar date picket widget
    // See https://vue3datepicker.com/
    import VueDatePicker                from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';
    import EditAsset                    from '@/components/Assets/EditAsset.vue'

    // Barcode (CODE39) support
    import Vue3Barcode                  from 'vue3-barcode'

    // support for barcode printer
    // pdf converter  install as npm install --save dom-to-pdf
    //import domToPdf                     from 'dom-to-pdf'
    import { useVueToPrint }            from "vue-to-print"

    // import enumerations
    import Configs                      from  '@/configuration/form-options.json'
    import Typology                     from  '@/configuration/assetTypology.json'
   
    export default {
        components: {
            VueDatePicker,
            EditAsset,
            Vue3Barcode
        },
        props: [
            'claims',
            'gat'
        ],
        emits: [

        ],
    
        setup(props)    {

            const {assetResults, assetKeyData, fetchAssetsOnQuery, fetchAssetsOnOrgs, storeAsset} = useAssetsAPI()
            const store                         =   useStore()
            const { checkStoreForRefresh }      =   useRefreshAPI()
            const { checkAdminGroups }          =   usePermissionsAPI()   

            // these are refs and must be unwrapped with .value

            const user                  =   computed( () => store.state.user)
            const config                =   computed( () => store.state.config)

            const systemAdministrator   =   computed( () => store.state.user['is-sys-admin'])
            const deptAdministrator     =   computed( () => store.state.user['is-dept-admin'])
            const activeRole            =   computed( () => store.state.user['active-role'])

            const aAssetTypes       =   ref([])
            const aDataClass        =   ref([])
            const aAuditCat         =   ref([])
            const aChartEnums       =   ref([])
            const aPropClass        =   ref([])
            const aAssetStatus      =   ref([])

            const configs           =   ref([])
            configs.value           =   Configs
            const typology          =   ref([])
            typology.value          =   Typology['asset-typology']

            // create dropdown type list from asset typology
            let rawTypes            =   typology.value
            rawTypes.forEach( (a) =>    {
                aAssetTypes.value.push(a.atype)
            })          
            aDataClass.value        =   configs.value['data-classification-types']
            aAuditCat.value         =   configs.value['audit-categories']
            aChartEnums.value       =   configs.value['chart-enums']
            aPropClass.value        =   configs.value['property-class']
            aAssetStatus.value      =   configs.value['asset-status']

 
            // use variables
            const asset             =   ref({
                "steward":                  "",
                "steward-netid":            "",
                "owner-org":                config.value['apply-orgcode'],
                "asset-type":               "Select asset type ...",  // placeholder
                "tag":                      "",
                "serial-no":                "",
                "audit-category":           "",
                "date-last-audit":          "",
                "mfg":                      "",
                "model":                    "",
                "machine-name":             "",
                "os-type":                  "",
                "os-version":               "",
                "description":              "",
                "storage-location":         "",
                "source-code":              "",
                "en-disk_encrypted":        false,
                "disk-encrypted":           null,
                "en_crowdstrike-active":    false,
                "crowdstrike-active":       null,
                "en_firewall-active":       false,
                "firewall-active":          null,
                "ipv4-address":             "",
                "en-av-installed":          false,
                "av-installed":             null,
                "av-name":                  "",
                "av-version":               "",
                "en-has-sensitive-data":    false,
                "has-sensitive-data":       null,
                "data-class":               "",
                "en-user-is-admin":         false,
                "chart":                    "Urbana",           
                "cost":                     null,    
                "category":                 "3-year property",      
                "otag":                     "", 
                "location":                 "109995", 
                "location-detail":          "Storage (pre-deployment) - DCL",
                "invoice-number":           "",
                "it-data":                  "",
                "notes":                    "",
                "orig-item-id":             "", 
                "purchase-date":            "",
                "replacement-cycle":        "",
                "status":                   "",      
                "unit":                     "1-NT-798",
                "warranty-expiration":      "",
                "user-is-admin":            null
            })
            const reversionAsset    =   ref({}) 
            reversionAsset.value    =   JSON.parse(JSON.stringify(asset.value))

            // for continuing 
            const newAsset    =   ref({}) 
            newAsset.value    =   JSON.parse(JSON.stringify(asset.value))

            const renderState       =   ref("EDIT-ASSET")

            const bc39Config        =   ref({
                "format":               "CODE39",
                "width":     	        2,
                "height":               100,
                "displayValue":  	    true,
                "text":                 null,
                "fontOptions": 	        "",
                "font": 	            "monospace",
                "textAlign": 	        "center",
                "textPosition":      	"bottom",
                "textMargin":    	    2,
                "fontSize":      	    20,
                "background":	        "#ffffff",
                "lineColor": 	        "#000000",
                "margin":    	        10,
                "marginTop":            null,   
                "marginBottom":         null,
                "marginLeft":           null,
                "marginRight":          null,
                "flat":  	            false,
                "valid": 	            function(valid){}
            })
            const printerConfig     =   ref({
                "type":                 "thermal",
                "model":                "",
                "user":                 user.value.netid        
            })

            // MARK:  refresh store from database if global browser refresh fubars the store
            checkStoreForRefresh()
            checkAdminGroups(props.claims, store)

            const calcNPV = computed( () =>   {

                // check mandatory props            
                if(   (asset.value['purchase-date'] == "")
                    || (asset.value['cost'] == 0.00) 
                    || (asset.value['category'] == "")) return ""

                let currentDate = new Date()
                let purchaseDate = new Date(asset.value['purchase-date'])
                let elapsedMs = currentDate.getTime() - purchaseDate.getTime()

                //get greatest frational whole integer
                let periods = Math.floor(elapsedMs/(1000 * 60 * 60 * 24 * 365))     // number ms in year    
                let annualDepreciation = 0.0 
                let npv = 0.0
                switch (asset.value['category']) {
                    case '3-year':
                    case '3-year property':
                        annualDepreciation = asset.value['cost']/3.0
                        if(periods >= 3) npv = annualDepreciation
                        else npv = asset.value['cost'] - periods*annualDepreciation
                        break;

                    case '5-year':
                    case '5-year property':
                        annualDepreciation = asset.value['cost']/5.0
                        if(periods >= 5) npv = annualDepreciation
                        else npv = asset.value['cost'] - periods*annualDepreciation
                        break;

                    case '7-year':
                    case '7-year property':
                        annualDepreciation = asset.value['cost']/7.0
                        if(periods >= 7) npv = annualDepreciation
                        else npv = asset.value['cost'] - periods*annualDepreciation
                        break;

                    case '10-year':
                    case '10-year property':
                        annualDepreciation = asset.value['cost']/10.0
                        if(periods >= 10) npv = annualDepreciation
                        else npv = asset.value['cost'] - periods*annualDepreciation
                        break;
                
                }
                if(isNaN(npv) || npv == 'undefined') return ""
                else return npv.toFixed(2)      
                
              
            })


            return {user, config, deptAdministrator, systemAdministrator, activeRole, asset, reversionAsset, newAsset, 
                    renderState, aAssetTypes, aDataClass, aAuditCat, aChartEnums, aPropClass, aAssetStatus, calcNPV,
                    bc39Config, printerConfig, configs, typology }
        },

        data() {
            return {
                savedFlag:      false
            }
        },
        methods:  {
            prettyDate(date)     {
                const {makePrettyDate}      =   useDateHelpers()
                return makePrettyDate(date)  
            },
            // Function: converts status enumeration to more readable 
            prettyType(s) {
                if (!s) return ""
                s = s.replaceAll('_',' ')
                let aW = s.toLowerCase().split(' ')
                for (let i = 0; i < aW.length; i++) {
                    aW[i] = aW[i].charAt(0).toUpperCase() + aW[i].slice(1);
                }
                return aW.join(' ')
            },

            // FUNCTION:  Generates a unique asset number from NAN generator on
            // number set 'unique-asset-id' and cast into form NT-YR-00000N.
            // sets aAsset temporary asset object.tag
            generatePTAG() {
                const {nextNumber, fetchNextNumber} =   useNextAvailableNumberAPI()          
                const {configResults, fetchConfigsOnQuery} = useConfigAPI()

                // if tag was set by user, don't invoke tag next available number generator
                if(this.asset['tag'].length != 0) return

                // generate a tag in the form <prefix>-YY-NNNN
                let dt = new Date()
                let year = dt.getFullYear().toString().substring(2)

                // use the entered owner-org as a query key to identify any configuration stored
                // and retrieve tag-prefix.  If not found, use 'UN' as default

                fetchConfigsOnQuery({"apply-orgcode":this.asset['owner-org']}) 
                .then( () => {
                    let prefix = 'UN'
                    if(configResults.value.length != 0) {       
                        // received a config set on that applied-orgcode
                        if(configResults.value[0].hasOwnProperty('tag-prefix')) {
                            prefix = configResults.value[0]['tag-prefix']
                        }  
                    }
                    //constructed tag
                    let numberSet = prefix+'-'+year                       
                    fetchNextNumber({"set-name":numberSet})
                    .then( () =>    {
                        let tag = numberSet + "-" + nextNumber.value
                        this.asset['tag'] = tag
                    })
                })
                
                
            },
            generateDateToday()    {
                
                let dt = new Date().toString()
                this.asset['purchase-date'] = this.prettyDate(dt)
            },         
            useFormat(date) {
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                return `${month}/${day}/${year}`;
            },
            // FUNCTION to save an asset to database
            async saveAsset() {

                const {assetResults, assetKeyData, fetchAssetsOnQuery, storeAsset} = useAssetsAPI()

                // default until IT issues asset
                this.asset['status']    =   "Active-Pending-Issue"

                // set audit category based on type
                this.asset['audit-category'] = this.typology.find( (t) => t.atype == this.asset['asset-type'])['audit-cat']
                this.asset['steward']   =   "Not yet issued"

                // some idiot might put cost in with $5000 verses 500 so filter out non decimal characters
                // leaving only [0-9.]
                if(this.asset['cost'])
                    this.asset['cost'] = this.asset['cost'].replaceAll( new RegExp(/[^0-9.]/,"g"), "")

                // add guard to Banner location code also
                if(this.asset['location'])
                    this.asset['location'] = this.asset['location'].replaceAll( new RegExp(/[^0-9]/,"g"), "")

                // update tag and dates
                this.generateDateToday()
                this.generatePTAG()

                await storeAsset(this.asset)
                .then(async () => {  
                    await fetchAssetsOnQuery({"id": assetKeyData.value[0]['pkey'] })
                    .then( () => {
                        this.asset = assetResults.value[0]
                    })
                    this.savedFlag  =   true     
                    this.renderState = "REVIEW-ASSET"

                    this.reversionAsset    =   JSON.parse(JSON.stringify(this.asset))

                })    
            },
            cancelEdit()    {
                this.asset = JSON.parse(JSON.stringify(this.reversionAsset))
                this.renderState = "EDIT-ASSET"
            },
            cancelReEdit()    {
                this.asset = JSON.parse(JSON.stringify(this.reversionAsset))
                this.renderState = "REVIEW-ASSET"
            },
            anotherAsset() {
                this.asset = JSON.parse(JSON.stringify(this.newAsset))
                this.renderState    =   "EDIT-ASSET"
                this.savedFlag      =   false 
            },
            editAsset() {                
                this.renderState = "REEDIT-ASSET"
                this.savedFlag = false
            },
            // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
            // 
            //   PRINT A DIV OPENING THE PRINT DIALOG
            //
            //   Note:  Since there is no direct connection from a browser's javascript container 
            //          to a system module - e.g. the printer dialog, printer parameters MUST
            //          be set from the dialog and cannot be preset by the applicaiton.
            //
            // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
            async printPTAG() {
                
                let el = document.getElementById('_tag_pdf')
                const { handlePrint } = useVueToPrint({
                    content: () => el,
                    documentTitle: "",
                    // other  options here
                    bodyClass: "_tag_print_format"

                });    
                handlePrint()
            }

        },

        // hooks
        beforeMount() {
        },
        mounted() {
            
        },
        updated() {
            //console.log("asset: "+JSON.stringify(this.asset))       
         }
    }
</script>

<style scoped>

    ._master_container   {
        width: 90vw;
        height: 90%;
        font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
        margin: 5px auto;
        padding: 5px;  
    }
    ._fieldset_edit {
        width: 60%;
        margin: 5px auto;
        padding: 5px;
    }
    ._fieldset_form {
        margin: 0;
        padding: 5px;
    }
    ._fieldset_flex_row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        width: 100%;
        margin: 5px 25px;
        padding: 5px;  
    }
    ._fieldset_flex_col {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: flex-start;
        width: 50%;
        margin: 5px 25px;
        padding: 5px;  
    }
    ._header_field {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        width: 100%;
        height: 130px;
        margin: 0;
        padding: 0;  
    }
    ._assets_controls {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 50%;
        margin: 5px auto;
        padding: 5px;  
    }
    /* general controls styling */
    ._main_button {
        background-color: #13294B;
        color: white;
        font-weight: bold;
        border-style: solid;
        border-width: 1px;
        border-radius: 4px;
        border-color: #13294B;
        margin: 5px 10px;
        padding: 5px;
    }
    ._main_button:hover {
        background-color: #FF5F05;
        color: white;
    }
  
    ._p_saved {
        font-size: 14pt;
        color: #FF5F05;
        padding: 2px;
    }
    ._saved_right {
        padding: 0 25px;
        margin: 0 50px 0 0;
        float: right;
    }
  
    ._form_blue {     
        max-width: 100%;
        margin: 0;
        background: #BFC9D9;
        text-align: left; 
        padding: 5px;
        border-radius: 10px;
    }

    ._p_fr_container_label {
        color: #13294B;
        font-weight: bold;
        font-size: 1.2em;
        margin: 10px 0 5px 0;
        text-align: left;
        padding: 0;
    }
    br {
        margin: 0;
    }
    ._date_picker {
        --dp-font-size: 0.8em;
        --dp-input-padding: 6px 10px 6px 10px;
        --dp-text-color: blue;
    }
    ._p_item_label {
        color: #13294B;
        font-size: 0.9em;
        font-weight: bold;
        text-align: left;
        margin: 1px 0 0 0;
        padding: 0;
    }
  
    ._p_item_text {
        color: black;
        font-size: 1.0em;
        font-weight: normal;
        text-align: left;
        margin: 1px 0 0 0;
        padding: 0 3px;
    }
    ._p_item_text_diminished {
        color: black;
        font-weight: normal;
        font-size: 0.9em;
        text-align: left;
        padding: 0 3px;
    }
    ._property_box_blue {
        background: #BFC9D9;
        border-style: solid;
        border-width: 2px;
        border-color: #13294B;
        text-align: left;
        padding: 0 5px;
    }
    ._p_diminished_grn {
        text-align: left;
        font-size:  0.8em;
        color: #006230;
        margin: 0;
        padding: 0 2px 0 2px;
    }   
    ._major_property_container {
        width: 100%;
        font-size: 1.1em;
        text-align: left;
        margin: 5px 25px;
        padding: 5px;    
    }
    ._property_group_container {
        margin: 0 5px;
        padding: 0;
    }
    ._property_group_container_split {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        margin: 5px 25px;
        padding: 5px;     }

    ._p_group_container_label {
        color: #13294B;
        font-weight: bold;
        font-size: 0.9em;
        margin: 10px 0 0 0;
        text-align: left;
        padding: 0;
    }
    ._p_item_label {
        color: #13294B;
        font-weight: bold;
        text-align: left;
        margin: 1px 0 0 0;
        padding: 0;
    }
    ._p_item_check_label {
        width: 100%;
        color: #13294B;
        font-weight: normal;
        text-align: left;
        margin: 1px 0 0 0;
        padding: 0; 
    }
    ._p_item_text {
        color: black;
        font-weight: normal;
        text-align: left;
        margin: 1px 0 0 0;
        padding: 0 3px;
    }
    ._p_item_text_ellipsis {
        color: black;
        font-weight: normal;
        text-align: left;
        text-overflow: elipsis;
        margin: 1px 0 0 0;
        padding: 0 3px;
    }
    ._p_item_text_diminished {
        color: black;
        font-weight: normal;
        font-size: 0.9em;
        text-align: left;
        padding: 0 3px;
    }
    ._ui_tag_text {
        width: 350px;
        font-size: 1.0em;
        margin: 0 auto;
        padding: 0;
        text-align: center;
    }    
    ._ui_tag_code {
        width: 350px;
        font-size: 1.0em;
        margin: 0 auto;
        padding: 0;
        text-align: center;
    }
    ._property_group_box {
        background: #BFC9D9;
        border-style: solid;
        border-width: 2px;
        border-color: #13294B;
        text-align: left;
    }
    ._property_group_box_audit {
        height: 90%;
        background: #f9da98;
        border-style: solid;
        border-width: 2px;
        border-color: #13294B;
        text-align: left;
        padding: 0 5px;
    }
    ._checks {
        width: 5%;
        text-align: center;
        margin: 0;
        padding: 0;
    }
    ._assets_table {
        width: 100%;
        display: table;
        padding: 5px 0;
    }
    ._row   {
        content: "";
        display: flex;
        flex-direction: row;
        align-content: left;
        justify-content: left;
        flex-wrap: no-wrap;
        clear: both;
        font-size: 1.0em;
        font-weight: normal;
        color: black;
        margin: 0;
        padding: 0;
    }
 
    ._assets_check_label_table_cell {
        display: table-cell;
        min-width:70%;
        text-align: left;
        margin: 0;
        padding: 2px 0 2px 10px;
    }
    ._assets_check_table_cell {
        display: table-cell;
        margin: 0;
        padding: 2px 0 2px 10px;
    }
    ._fcn_button {
        margin: 0;
        padding: 0;
        order: 2;
        width: 95%;
        /* font-size: 0.7em; */
        background-color:#13294B;
        color: #E8E9EB;
        border-style: solid;
        border-width: 1px;
        border-radius: 4px;
        border-color: #13294B;
    }
    ._fcn_button:hover {
        background-color: #FF5F05;
        color: #E8E9EB;
    }
 
    ._col_50 {
        width: 50%;
        margin-top: 5px;
        padding: 2px 0 2px 10px;
    }


    ._col_20 {
        float: left;
        width: 20%;
        margin:5 px 0 0 0;
    }  
    ._col_30 {
        width: 30%;
        float: right;
        margin-top: 2px;
    }    
  
    ._col_40 {
        text-align: left;
        width: 40%;
        margin-top: 5px;
    }
    ._col_50 {
        width: 50%;
        margin: 0;
    }

    ._col_60 {
        float: left;
        width: 60%;
        margin-top: 5px;
    }
    ._col_65 {
        width: 65%;
        margin-top: 2px;
    }
   ._col_80 {
        float: right;
        width: 80%;
        margin: 5px 0 0 0;
    }
    ._col_60_tag {
        float: left;
        width: 60%;
        margin-top: 5px;
    }
    ._scol_50 {
        display: inline-block;
        width: 50%;
        margin-top: 5px;
    }

    ._input[type=text], ._select, ._asset_types, ._textarea {
        width: 100%;
        padding: 2px 10px;
        border: 1px solid #ccc;
        font-size: 1em;
        color: black;
        border-radius: 4px;
        box-sizing: border-box;
        resize: vertical;
    }
    ._asset_types:disabled {
        color: #006230;
    }
 
    ._label {
        display: inline-block;
        color: #13294B;
        font-weight: bold;
        font-size: 0.95em;
        text-align: left;
        padding: 2px 0;  
    }
    ._label:after {
        content:":";
    }
    ._check_label { 
        color: #13294B;
        font-weight: bold;
        font-size: 0.95em;
        text-align: left;
        margin: 2px  2px 15px;
        padding: 2px 5px;
    }
     /* checkbox styling */
    ._check {
        display: inline;
        width: 25px;
        margin: 5px auto;
        padding: 0;
        
    }
    @media screen and (max-width: 620px) {
        ._col_40, ._col_60, ._col_50 {
            width: 100%;
            margin-top: 0;
        }
        ._assets_controls {
            width: 50%;
            flex-wrap: wrap;
        }
        ._row {
            flex-wrap: wrap;
        }
        ._p_item_label, ._p_item_check_label {
            color: #13294B;
        }
    }
    @media screen and (max-width: 800px) {
        ._fieldset_flex_col {
            width: 100%;
        }
        ._fieldset_flex_row {
            flex-wrap: wrap;  
        }
    }
    ._tag_print_format {
        width: 350px;
        height: 150px;
        padding: 2px;
        margin: 10px;
    }


</style>